/**
 * Syncs header Login / My Account with Uplift auth.
 * Primary signal: pf_local_accessToken (+ expiry). Fallback: user-store.
 * Works with dual CTAs (--login / --account) or a single account CTA.
 */
(function () {
  const ACCOUNT_URL = '/a/accounts';
  const ACCOUNT_LABEL = 'My Account';
  const LOGIN_LABEL = 'Login';
  const TOKEN_KEY = 'pf_local_accessToken';
  const TOKEN_EXPIRY_KEY = 'pf_local_tokenExpiry';
  const USER_STORE_KEY = 'user-store';

  function onAccountPage() {
    return (window.location.pathname || '').indexOf('/a/accounts') === 0;
  }

  function hasUpliftTokens() {
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      if (!token) return false;
      const expiry = localStorage.getItem(TOKEN_EXPIRY_KEY);
      if (expiry && Date.now() > parseInt(expiry, 10)) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function hasUserStore() {
    try {
      const raw = localStorage.getItem(USER_STORE_KEY);
      if (!raw) return false;
      const parsed = JSON.parse(raw);
      const state = parsed?.state || parsed;
      return Boolean(state?.isAuthenticated || state?.sessionId || state?.customer?.id);
    } catch (e) {
      return false;
    }
  }

  function isAuthenticated() {
    if (document.documentElement.getAttribute('data-customer-logged-in') === 'true') {
      return true;
    }
    return hasUpliftTokens() || hasUserStore();
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.hidden = hidden;
    if (hidden) el.setAttribute('aria-hidden', 'true');
    else el.removeAttribute('aria-hidden');
  }

  function isAccountHref(href) {
    return typeof href === 'string' && href.indexOf('/a/account') !== -1;
  }

  function syncAuth() {
    const root = document.documentElement;
    const loggedIn = isAuthenticated();
    const onAccount = onAccountPage();

    root.setAttribute('data-tws-account-logged-in', loggedIn ? 'true' : 'false');
    if (onAccount) root.setAttribute('data-tws-on-account', 'true');
    else root.removeAttribute('data-tws-on-account');

    const loginEls = document.querySelectorAll(
      '.tws-header__cta--login, .header__cta--login, .tws-header__secondary, .tws-header__login'
    );
    const accountEls = document.querySelectorAll('.tws-header__cta--account, .header__cta--account');

    if (loginEls.length || accountEls.length) {
      if (onAccount) {
        loginEls.forEach((el) => setHidden(el, true));
        accountEls.forEach((el) => setHidden(el, true));
      } else {
        loginEls.forEach((el) => setHidden(el, loggedIn));
        accountEls.forEach((el) => setHidden(el, !loggedIn));
      }
    }

    // Fallback for themes/pages that still render a single Login CTA.
    document.querySelectorAll('.tws-header__cta, .header__cta a.btn').forEach((el) => {
      if (
        el.classList.contains('tws-header__cta--login') ||
        el.classList.contains('tws-header__cta--account')
      ) {
        return;
      }

      const href = el.getAttribute('href') || '';
      if (!isAccountHref(href) && el.textContent.trim().toLowerCase() !== 'login') return;

      if (onAccount) {
        setHidden(el, true);
        return;
      }

      setHidden(el, false);
      el.textContent = loggedIn ? ACCOUNT_LABEL : LOGIN_LABEL;
      el.setAttribute('href', ACCOUNT_URL);
      el.classList.toggle('tws-header__cta--account', loggedIn && el.classList.contains('tws-header__cta'));
    });
  }

  syncAuth();
  window.TwsHeaderAccount = { sync: syncAuth };

  window.addEventListener('pageshow', syncAuth);
  window.addEventListener('storage', (event) => {
    if (
      !event.key ||
      event.key === TOKEN_KEY ||
      event.key === TOKEN_EXPIRY_KEY ||
      event.key === USER_STORE_KEY
    ) {
      syncAuth();
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="logout" i], a[href*="log-out" i]');
    if (link) window.setTimeout(syncAuth, 250);
  });

  if (onAccountPage()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      syncAuth();
      attempts += 1;
      if (attempts >= 24) window.clearInterval(timer);
    }, 500);
  }
})();
